var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"m-auto btn-base",class:{ 'btn-outline': _vm.outline, 'btn-contained': !_vm.outline },attrs:{"disabled":_vm.isLoading},on:{"click":_vm.onOpen}},[(_vm.hasSlot)?_vm._t("default"):[_vm._v("\n        "+_vm._s(_vm.premium
                ? _vm.hasPremium
                    ? _vm.$t("assessments.general.startTest")
                    : _vm.$t("assessments.general.unlock", { price: _vm.premiumPrice, currency: '€' })
                : _vm.hasConsented
                ? _vm.$t("assessments.general.startTests")
                : _vm.$t("assessments.general.takeTheFreeTests"))+"\n    ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }